import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ccc2304"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "discount-message"
}
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "ms-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiTypography = _resolveComponent("AsahiTypography")!

  return (_ctx.displayDiscountMessage)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("img", { src: _ctx.attention }, null, 8, _hoisted_3)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_AsahiTypography, { type: "subtitle-1" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("You are ordering layers, you will loose the logistic discount. Order only full pallets!")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}